import React, { useState, useEffect } from 'react'
import Loader from '../../../presentationals/Loader/Loader.component'
import { getVehicleInsuranceList, getVehicleInsuranceListCount, deleteVehicleInsurancebyId, DownloadInsuranceList } from '../AdminActionCreator.component';
import Pagination from '@mui/material/Pagination';
import Popup from '../../../presentationals/Popup/Popup.component'

const ItemsPerPage = 10;
export default function List({ handleType }) {
    const [loadarState, setloadarState] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [allUserDetail, setallUserDetail] = useState([]);
    const [totalItems, setTotalItems] = useState("")
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })

    useEffect(() => {
        handleListAPi(currentPage)
        getVehicleInsuranceListCountFn()
    }, [])

    const handleListAPi = (page) => {
        setloadarState(true)
        getVehicleInsuranceList(page, ItemsPerPage, callback => {
            setloadarState(false)
            console.log("cal", callback)
            setallUserDetail(callback?.data)
        })
    }

    const getVehicleInsuranceListCountFn = () => {
        setloadarState(true)
        getVehicleInsuranceListCount(callback => {
            setloadarState(false)
            setTotalItems(callback?.data || 0)
        })
    }

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        handleListAPi(value)
    };


    const hanldeDelete = (data) => {
        setloadarState(true)
        deleteVehicleInsurancebyId(data?.userId, callback => {
            setloadarState(false)
            setCurrentPage(1)
            getVehicleInsuranceListCountFn()
            handleListAPi(1)
            if (callback?.message == "success") {
                setPopup({ show: true, popupStatus: "Data Deleted Successfully" })
            } else {
                setPopup({ show: true, popupStatus: "Error Deleting Data" })
            }
            removePopup()
        })
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const handleInfo = (data) => {
        handleType("details", data)
    }

    const handleDownload =()=>{
         setloadarState(true)
        DownloadInsuranceList(callback=>{
             setloadarState(false)
        })
    }

    return (
        <>
            {
                popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
            }
            <div className="container-fluid" style={{ padding: '0 20px' }}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <h3 className='blue-text'>Insurance</h3>
                <button className='btn btn-primary' onClick={()=>handleDownload()}>Download <i className='fa fa-download'></i></button>
                </div>
                <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-xs-12 no-padding overflow-auto">
                        {loadarState == false ?
                            allUserDetail != null ? allUserDetail.length > 0 ?
                                <>
                                    <table className='phocket-table'>
                                        <thead>
                                            <tr>
                                                <td>Details</td>
                                                <td>Customer Name</td>
                                                <td>Email Id</td>
                                                <td>Mobile No.</td>
                                                <td>Status</td>
                                                <td>Dealer Name</td>
                                                <td>Edit</td>



                                            </tr>
                                        </thead>

                                        <tbody>
                                            {allUserDetail && allUserDetail.map((data, i) => {
                                                return (
                                                    <tr>
                                                        <td><i className='fa fa-info-circle' onClick={() => handleInfo(data)}></i></td>
                                                        <td>{data?.customerName}</td>
                                                        <td>{data?.emailId}</td>
                                                        <td>{data?.contactNumber}</td>
                                                        <td className='light-dark-background'>
                                                                {data?.status?.charAt(0)?.toUpperCase() + data?.status?.slice(1)}
                                                        </td>
                                                        <td>{data?.communityName}</td>
                                                        <td><i className='fa fa-trash' onClick={() => hanldeDelete(data)}></i></td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                    <div style={{ float: 'right', marginTop: '15px' }}>
                                        <Pagination
                                            count={Math.ceil(totalItems / ItemsPerPage)}
                                            page={currentPage}
                                            onChange={handlePageChange}
                                            color="success"
                                        />
                                    </div>
                                </>


                                : "" : "" :
                            <Loader />}

                    </div>
                </div>
            </div>
        </>
    )
}
